<template>
  <crud-show :title="getTitle" :open="dialog" @close="$emit('close')">
    <v-row v-if="receipt">
      <v-col cols="12" sm="12" md="12">

        <v-card class="my-0">


          <v-card-text v-if="errorMessage">
            <v-alert type="error">
              {{ errorMessage }}
            </v-alert>
          </v-card-text>

          <v-card-text v-else-if="receipt.Error">
            <v-alert type="error">
              {{ receipt.Error }}
            </v-alert>
          </v-card-text>

          <v-card-actions v-if="receipt.Estado === 'PENDIENTE' || receipt.Estado === 'ERROR'">
            <span v-if="receipt.Estado === 'PENDIENTE'" class="text-h7"><b>BORRADOR</b>: La factura aun no se emitió en AFIP</span>
            <v-spacer></v-spacer>
            <v-btn color="red white--text" @click="emitirFactura" :loading="ebLoading">
              <v-icon left>send</v-icon>
              Emitir en AFIP
            </v-btn>
          </v-card-actions>

          <v-card-actions v-if="receipt.Estado === 'FACTURADO'">
            <v-btn v-if="qrAfip" target="_blank" color="green white--text" :href="qrAfip.url">
              <v-icon left>verified</v-icon>
              Validar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="blue white--text" @click="getTicketFactura">
              <v-icon left>receipt_long</v-icon>
              Ticket
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="teal white--text" @click="getFacturaPdf">
              <v-icon left>picture_as_pdf</v-icon>
              Factura
            </v-btn>
          </v-card-actions>
        </v-card>

      </v-col>

      <v-col cols="12" sm="5" md="5">
        <v-card outlined class="fill-height ">
          <v-card-title class="pb-0">{{ NombreFantasia }}</v-card-title>
          <v-list dense>
            <v-list-item><b class="mr-1">Razón Social: </b> {{ NombreLegal }}</v-list-item>
            <v-list-item><b class="mr-1">Domicilio Comercial: </b> {{ Domicilio }}</v-list-item>
            <v-list-item><b class="mr-1">Condición frente al IVA: </b> {{ CondicionIva }}</v-list-item>
          </v-list>
        </v-card>

      </v-col>

      <v-col cols="12" sm="2" md="2">
        <v-card outlined class="text-center fill-height d-flex align-center justify-center  ">

          <h1 v-if="receipt.Estado === 'FACTURADO'" class="text-h1">{{ getCbteLetter(receipt.CbteTipo) }}</h1>

          <v-row v-else no-gutters justify="center" align="center">
            <v-sheet class=" align-self-center justify-center">
              <v-select
                  solo
                  class="superSelect mt-5"
                  v-model="receipt.CbteTipo"
                  :items="getCbteTipoList"
                  height="150"
                  hide-details
                  @change="updateFactura"
              >
                <template v-slot:selection="{item}">
                  <span class="text-h1 text-center  ">{{ item.text }}</span>
                </template>
              </v-select>
            </v-sheet>
          </v-row>


        </v-card>

      </v-col>

      <v-col cols="12" sm="5" md="5">
        <v-card outlined class="fill-height">
          <v-list dense>
            <v-list-item>

              <template v-if="receipt.Estado === 'FACTURADO'">
                <b class="mr-1">Punto de venta: </b> {{ completeZeros(receipt.PtoVta,5) }}
                <b class="ml-6 mr-1">Comp. Nro: </b>{{ receipt.VoucherNumber ? completeZeros(receipt.VoucherNumber, 8) : 'XXXXXXXX' }}
              </template>

              <template v-else>
                <punto-venta-setting-combobox v-model="receipt.PtoVta" width="100px" @input="updateFactura"></punto-venta-setting-combobox>
              </template>



            </v-list-item>
            <v-list-item><b class="mr-1">Fecha: </b> {{ getDateFormat(receipt.CbteFch) }}</v-list-item>
            <v-list-item><b class="mr-1">CUIT: </b> {{ CUIT }}</v-list-item>
            <v-list-item v-if="IngresosBrutos"><b class="mr-1">Ingresos Brutos: </b> {{ IngresosBrutos }}</v-list-item>
            <v-list-item><b class="mr-1">Fecha de Inicio de Actividades: </b> {{ InicioActividades }}</v-list-item>
          </v-list>
        </v-card>
      </v-col>


      <v-col cols="12" sm="12" md="12">
        <v-card outlined>
          <v-row>
            <v-col cols="12" sm="6">
              <v-list dense>
                <v-list-item><b class="mr-1">CUIT: </b> {{ receipt.DocNro }}</v-list-item>
                <v-list-item><b class="mr-1">Condición frente al IVA: </b> {{ receipt.CondicionIVAReceptor }}
                </v-list-item>
                <v-list-item><b class="mr-1">Condición de venta: </b> {{ receipt.CondicionVenta }}</v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" sm="6">
              <v-list dense>
                <v-list-item><b class="mr-1">Apellido y Nombre / Razón Social: </b> {{ receipt.RazonSocialReceptor }}
                </v-list-item>
                <v-list-item><b class="mr-1">Domicilio Comercial: </b> {{ receipt.DomicilioReceptor }}</v-list-item>
              </v-list>
            </v-col>
          </v-row>

        </v-card>
      </v-col>


      <v-col cols="12" sm="12" md="12">
        <v-card outlined>
          <v-data-table
              :headers="detalleProductoServicioHeader"
              :items="receipt.detalleProductoServicio"
              hide-default-footer
              :items-per-page="-1"
          >

            <template v-slot:item.precioUnitario="{item}">
              {{ currencyFormat(item.precioUnitario) }}
            </template>
            <template v-slot:item.precioUnitarioConIva="{item}">
              {{ currencyFormat(item.precioUnitarioConIva) }}
            </template>
            <template v-slot:item.subtotal="{item}">
              {{ currencyFormat(item.subtotal) }}
            </template>
            <template v-slot:item.alicuotaIvaPorcentaje="{item}">
              {{ item.alicuotaIvaPorcentaje }}%
            </template>
            <template v-slot:item.subtotalConIva="{item}">
              {{ currencyFormat(item.subtotalConIva) }}
            </template>
          </v-data-table>

        </v-card>
      </v-col>


      <v-col cols="12" sm="12" md="12">
        <totales-factura :receipt="receipt"></totales-factura>
      </v-col>


      <v-col cols="12" sm="6" md="6">
        <img v-if="qrAfip" :src="qrAfip.imageData"/>
      </v-col>

      <v-col cols="12" sm="6" md="6" class="text-right">
        <b>CAE: </b> {{ receipt.CAE }}<br>
        <b>CAE VTO: </b> {{ receipt.CAEFchVto }}
      </v-col>

    </v-row>


  </crud-show>

</template>

<script>
import AfipMixin from "@/modules/afip/mixins/AfipMixin";
import FacturaMixin from "@/modules/afip/mixins/FacturaMixin";
import {CrudShow} from '@dracul/common-frontend'
import {DayjsMixin} from '@dracul/dayjs-frontend'
import PuntoVentaSettingCombobox from "@/modules/afip/components/PuntoVentaSettingCombobox/PuntoVentaSettingCombobox";
import CurrencyMixin from "@/modules/afip/mixins/CurrencyMixin";
import TotalesFactura from "@/modules/afip/components/TotalesFactura/TotalesFactura";

export default {
  name: "FacturaDialog",
  components: {TotalesFactura, PuntoVentaSettingCombobox, CrudShow},
  mixins: [AfipMixin, FacturaMixin, CurrencyMixin, DayjsMixin],
  props: {
    dialog: {type: Boolean, default: false}
  },
  computed: {
    getTitle() {
      return "FACTURA"
    },
    detalleProductoServicioHeader() {
      //A
      if (this.receipt.CbteTipo === 1) {
        return [
          {text: "Código", value: "codigo"},
          {text: "ProductoServicio", value: "ProductoServicio"},
          {text: "Cantidad", value: "cantidad"},
          {text: "Unidad Medida", value: "unidadMedida"},
          {text: "Precio Unitario", value: "precioUnitario"},
          {text: "subtotal", value: "subtotal"},
          {text: "Alicuota IVA", value: "alicuotaIvaPorcentaje"},
          {text: "Subtotal con IVA", value: "subtotalConIva"},
        ]
        //B
      } else if (this.receipt.CbteTipo === 6) {
        return [
          {text: "Código", value: "codigo"},
          {text: "ProductoServicio", value: "ProductoServicio"},
          {text: "Cantidad", value: "cantidad"},
          {text: "Unidad Medida", value: "unidadMedida"},
          {text: "Precio Unitario", value: "precioUnitarioConIva"},
          {text: "subtotal", value: "subtotalConIva"},
        ]
        //C
      } else {
        return [
          {text: "Código", value: "codigo"},
          {text: "ProductoServicio", value: "ProductoServicio"},
          {text: "Cantidad", value: "cantidad"},
          {text: "Unidad Medida", value: "unidadMedida"},
          {text: "Precio Unitario", value: "precioUnitario"},
          {text: "subtotal", value: "subtotal"},
        ]
      }

  }
},
  async created()
{
  // await this.getServerStatus()
  // await this.getTipoComprobantes()
  // await this.getTipoConceptos()
  // await this.getTipoDocumentos()
  // await this.getTipoAlicuotas()
  // await this.getPuntosVenta()

  this.getQrAfip()
}
,
data()
{
  return {}
}
}
</script>

<style scoped>
.superSelect {
  width: 120px;
}

</style>
